import * as React from "react";
import { NavLink } from "react-router-dom";
import * as Glob from "../Globale";
import * as Dati from "../Dati";
import { BaseComponent, BinderProductsTab, BottoneAPI, CampoData, CampoNumero, ChiamaAPI, DocumentComponent, Tipo, Trad } from "../components/";
import { CDatiBinder } from "../Dati";

interface IBinderState {
    //CRisAPIDato.Dato contiene i dati del binder in RisAPI e lista dei prodotti del binder in Extra
    Dato: Dati.CRisAPIDatoTipiBinder;
    ID_Binder: number;
    _ID_AnagDa: number;
}

export interface IBinderProduct extends Dati.CDatiBinderProdotto {
    Index: number;
}

export class Binder extends BaseComponent<Glob.IRouteGlobaleProps, IBinderState> {
    public constructor(props: any) {
        super(props);
        this.state = {
            Dato: new Dati.CRisAPIDatoTipiBinder(),
            ID_Binder: (this.props.match.params as any).ID_Binder,
            _ID_AnagDa: -1
        };
        this.OnRis = this.OnRis.bind(this);
        this.OnChange = this.OnChange.bind(this);
        this.OnErrore = this.OnErrore.bind(this);
    }

    static getDerivedStateFromProps(props: Glob.IRouteGlobaleProps, state: IBinderState): IBinderState {
        state.ID_Binder = (props.match.params as any).ID_Binder;
        return state;
    }

    private OnRis(sender: ChiamaAPI, dati: Dati.CRisAPIDatoTipiBinder, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            if (!dati.Errore) {
                dati.Dato.Extra = dati.Dato.Extra.sort((a: Dati.CDatiBinderProdotto, b: Dati.CDatiBinderProdotto) => a.ID_Binder - b.ID_Binder);

                this.setState({ Dato: dati });
            } else {
                if (dati.Dato != undefined) {
                    dati.Dato.RisAPI = new CDatiBinder();
                    this.setState({ Dato: dati });
                } else {
                    Glob.InfoModaleError(Trad.Trad("BINDER ERRORE"), Trad.Trad(dati.ErrTesto));
                    return false;
                }
            }
            this.setState({ _ID_AnagDa: dati.Dato.RisAPI.ID_AnagDa });
            if (dati.Dato.RisAPI.ID_Binder > 0) {
                this.SetMenu(11);
            } else {
                this.SetMenu(0);
            }
        }
        return false;
    }

    // private OnRisFiles(sender: ChiamaAPI, dati: Dati.CRisAPIDato<Dati.CDocument[]>, datiNuovi: boolean, id_BinderCompagnia: number, id_TipoProdotto: number): React.ReactNode {
    //     if (datiNuovi) {
    //         if (!dati.Errore) {
    //             console.log(dati.Dato)
    //             return <DocumentComponent Files={JSON.stringify(dati.Dato)} Label={Trad.Trad("DIP")}
    //                                       ExtendedValues={'{"ID_BinderCompagnia": ' + id_BinderCompagnia + ', "ID_TipoProdotto": ' + id_TipoProdotto + '}'}
    //                                       SaveURL="/api/Document/SaveBinderProductFileAsync"/>
    //         } else {
    //             Glob.InfoModaleWarning(Trad.Trad("WARNING"), Trad.Trad(dati.ErrTesto));
    //         }
    //     }
    //     return false;
    // }

    private SetMenu(menu: number) {
        var M = Glob.GetMenu();
        M.Main = "Home";
        M.ID_MenuMain = menu;
        this.props.SetMenu(M);
    }

    private OnRisProdotti(sender: ChiamaAPI, dati: Dati.CRisAPIListaTipi<Dati.CDatiBinderProdotto>, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi && this.state.ID_Binder == 0) {
            let stateDato = this.state.Dato;
            stateDato.Dato.Extra = dati.Dati;
            this.setState({ Dato: stateDato });
        }

        if (dati.Dati != undefined && dati.Dati[0] != undefined) {
            let DatiBinder = this.state.Dato.Dato.Extra;

            for (let x: number = 0; x < DatiBinder.length; x++) {
                for (let y: number = 0; y < dati.Dati.length; y++) {
                    if (DatiBinder[x].ID_Binder == dati.Dati[y].ID_Binder && DatiBinder[x].ID_TipoProdotto == dati.Dati[y].ID_TipoProdotto) {
                        DatiBinder[x].LimiteAccessoriMAX = dati.Dati[y].LimiteAccessoriMAX;
                        DatiBinder[x].LimiteFlessibilitaMAX = dati.Dati[y].LimiteFlessibilitaMAX;
                        DatiBinder[x].LimiteDirittiFissiMAX = dati.Dati[y].LimiteDirittiFissiMAX;
                        DatiBinder[x].LimitePerSingoloContraenteMAX = dati.Dati[y].LimitePerSingoloContraenteMAX;
                        DatiBinder[x].LimitePerSingoloProdottoMAX = dati.Dati[y].LimitePerSingoloProdottoMAX;
                        DatiBinder[x].PremioMinimoMAX = dati.Dati[y].PremioMinimoMAX;
                        DatiBinder[x].ProvvigioniMAX = dati.Dati[y].ProvvigioniMAX;
                        DatiBinder[x].Files = JSON.parse("[]");
                    }
                }
            }

            let nav: React.ReactNode[] = [];
            let content: React.ReactNode[] = [];
            let groupId: number = DatiBinder[0].ID_Binder;
            let group: IBinderProduct[] = [{ ...DatiBinder[0], Index: 0 }];

            for (let T: number = 1; T <= DatiBinder.length; T++) {
                const product: Dati.CDatiBinderProdotto = DatiBinder[T] || {};

                if (groupId != product.ID_Binder) {
                    const itemIndex = nav.length;
                    const className = itemIndex == 0 ? " active" : "";

                    nav.push(
                        <li className="nav-item" key={T}>
                            <a className={`nav-link${className}`} data-toggle="tab" href="#" data-target={`#kt_tabs_${itemIndex}`}>
                                {group[0].Compagnia}
                            </a>
                        </li>
                    );
                    content.push(
                        <div className={`tab-pane${className}`} id={`kt_tabs_${itemIndex}`} role="tabpanel" key={T}>
                            <BinderProductsTab Products={group} ApprovalList={dati.Tipi["ListaApprovazioniRichieste"]} Editable={this._Scrittura} OnChange={this.OnChange} />
                        </div>
                    );
                    group = [];
                    groupId = product.ID_Binder;
                }
                group.push({ ...product, Index: T });
            }

            return (
                <div className="kt-portlet kt-portlet--brand kt-portlet--head-solid-bg">
                    <div className="kt-portlet__head">
                        <div className="kt-portlet__head-label">
                            <div className="kt-portlet__head-label">
                                <span className="kt-portlet__head-icon">
                                    <i className="fa fa-handshake" />
                                </span>
                                <h3 className="kt-portlet__head-label">{Trad.Trad("Prodotti")}</h3>
                            </div>
                        </div>
                    </div>
                    <div className="kt-portlet__body">
                        <ul className="nav nav-tabs" role="tablist">
                            {nav}
                        </ul>
                        <div className="tab-content">{content}</div>
                    </div>
                </div>
            );
        } else {
            return false;
        }
    }

    private OnClickSalva(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("BINDER ERRORE"), Trad.Trad(dati.ErrTesto));
        } else {
            this.setState({ ID_Binder: dati.ID_Chiave });
            this.props.history.replace("/binder/" + dati.ID_Chiave);
            Glob.InfoModaleSuccess(Trad.Trad("BINDER"), Trad.TradParam("Binder salvato correttamente con ID: {1-S}", [this.state.ID_Binder]));
            this.SetMenu(11);
        }
    }

    private OnInvioSalva(sender: BottoneAPI): any {
        var Ingr = new Dati.CIngrAPIExtra<Dati.CDatiBinder, Dati.CDatiBinderProdotto[]>();
        Ingr.IngrApi = this.state.Dato.Dato.RisAPI;
        var Extra: Dati.CDatiBinderProdotto[] = [];
        Extra = this.state.Dato.Dato.Extra;
        for (let i: number = 0; i < Extra.length; i++) {
            Extra[i].LimiteAccessoriMAX = 0;
            Extra[i].LimiteFlessibilitaMAX = 0;
            Extra[i].LimiteDirittiFissiMAX = 0;
            Extra[i].LimitePerSingoloContraenteMAX = 0;
            Extra[i].LimitePerSingoloProdottoMAX = 0;
            Extra[i].PremioMinimoMAX = 0;
            Extra[i].ProvvigioniMAX = 0;
        }

        Ingr.Extra = Extra;
        return Ingr;
    }

    private OnErroreBottoneAPI(sender: BottoneAPI, errore: Error) {}

    public render() {
        if (!this.ControlloAutorizzazione("BinderController")) {
            this.props.history.push("/ErroreAccesso");
            return false;
        }

        var caricaDocumenti = <div></div>;
        if (this.state.ID_Binder > 0) {
            caricaDocumenti = (
                <div className="kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push" aria-expanded="true">
                    <a
                        href={"/file/" + this.state.Dato.Dato.RisAPI.ID_Binder}
                        className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg black"
                        title={Trad.Trad("Documenti")}
                    >
                        <i className="fa fa-archive"></i>
                    </a>
                </div>
            );
        }

        return (
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <div className="kt-portlet__head-label">
                            <span className="kt-portlet__head-icon">
                                <i className="fas fa-handshake"></i>
                            </span>
                            <h3 className="kt-portlet__head-label">{Trad.Trad("Binder")}</h3>
                        </div>
                    </div>
                    <div className="portlet__head-tools">
                        <ul className="kt-portlet__nav">
                            {caricaDocumenti}
                            <div
                                className={"kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push " + this._VisibileScrittura}
                                aria-expanded="true"
                            >
                                <NavLink to="/binder/0" className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg black" title={Trad.Trad("Nuovo")}>
                                    <i className="fa fa-plus"></i>
                                </NavLink>
                            </div>
                        </ul>
                    </div>
                </div>
                <form className="kt-form login-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">
                    <div className="kt-portlet__body">
                        <div className="form-group kt-form login-form__group row">
                            <div className="col-lg-4">
                                <label>ID</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <input type="text" className="form-control kt-input" value={this.state.ID_Binder} readOnly />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <label className="">{Trad.Trad("Da")}</label>
                                <Tipo
                                    URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                    Campo="Dato.RisAPI.ID_AnagDa"
                                    ID_Chiave={this.state.Dato.Dato.RisAPI.ID_AnagDa}
                                    OnAggiorna={(c, v) => {
                                        this.OnChange(c, v);
                                        this.setState({ _ID_AnagDa: v });
                                    }}
                                    TradValori
                                    LinkSelezione="/anagrafica/"
                                />
                            </div>
                            <div className="col-lg-4">
                                <label className="">{Trad.Trad("A")}</label>
                                <Tipo
                                    URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                    Campo="Dato.RisAPI.ID_AnagA"
                                    ID_Chiave={this.state.Dato.Dato.RisAPI.ID_AnagA}
                                    OnAggiorna={this.OnChange}
                                    TradValori
                                    LinkSelezione="/anagrafica/"
                                />
                            </div>
                        </div>
                        <div className="form-group kt-form login-form__group row">
                            <div className="col-lg-4">
                                <label>{Trad.Trad("Codice binder")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={this.state.Dato.Dato.RisAPI.CodiceBinder || ""}
                                        name="Dato.RisAPI.CodiceBinder"
                                        onChange={e => {
                                            this.OnChange(e);
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <label>{Trad.Trad("CoAssicurazione minima")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <CampoNumero
                                        Id="Dato.RisAPI.CoAssicurazioneMinima"
                                        Valore={this.state.Dato.Dato.RisAPI.CoAssicurazioneMinima}
                                        OnChange={e => {
                                            this.OnChange(e);
                                        }}
                                        Name="Dato.RisAPI.CoAssicurazioneMinima"
                                        CSS="form-control kt-input"
                                        Precisione={2}
                                        Icona="fa fa-percentage"
                                        BarraLimiti
                                        Minimo={0}
                                        Massimo={100}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <label>{Trad.Trad("CoAssicurazione solo delegataria")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <span className="kt-switch kt-switch--outline kt-switch--icon kt-switch--brand">
                                        <label>
                                            <input
                                                type="checkbox"
                                                name="Dato.RisAPI.CoAssicurazioneSoloDelegataria"
                                                onChange={e => {
                                                    this.OnChange(e);
                                                }}
                                            />
                                            <span></span>
                                        </label>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="form-group kt-form login-form__group row">
                            <div className="col-lg-4">
                                <label className="">{Trad.Trad("Data effetto")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <div className="form-control">
                                        <CampoData
                                            ValoreInArrivo={this.state.ID_Binder > 0}
                                            Name="Dato.RisAPI.DataEffetto"
                                            Id="Dato.RisAPI.RisAPI.DataEffetto"
                                            Valore={this.state.Dato.Dato.RisAPI.DataEffetto}
                                            OnChange={this.OnChange}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4">
                                <label className="">{Trad.Trad("Data fine")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <div className="form-control">
                                        <CampoData
                                            ValoreInArrivo={this.state.ID_Binder > 0}
                                            Name="Dato.RisAPI.DataFine"
                                            Id="Dato.RisAPI.RisAPI.DataFine"
                                            Valore={this.state.Dato.Dato.RisAPI.DataFine}
                                            OnChange={this.OnChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <label className="">{Trad.Trad("Data stipula")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <div className="form-control">
                                        <CampoData
                                            ValoreInArrivo={this.state.ID_Binder > 0 && this.state.Dato.Dato.RisAPI.DataStipula != undefined}
                                            Name="Dato.RisAPI.DataStipula"
                                            Id="Dato.RisAPI.RisAPI.DataStipula"
                                            Valore={this.state.Dato.Dato.RisAPI.DataStipula}
                                            OnChange={this.OnChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ChiamaAPI
                            Aggiornare={
                                this.state._ID_AnagDa +
                                (this.state._ID_AnagDa == Glob.ChiamaAPINonAttivo || this.state.Dato.Dato.RisAPI.DataEffetto == undefined ? 0 : this.state.Dato.Dato.RisAPI.DataEffetto.valueOf())
                            }
                            URL={
                                "/api/binder/ProdottiBinderPadre?ID_AnagDa=" +
                                this.state._ID_AnagDa +
                                "&DataEffetto=" +
                                Glob.DataValore(this.state.Dato.Dato.RisAPI.DataEffetto) +
                                "&ID_Binder=" +
                                this.state.ID_Binder
                            }
                            OnRis={(s, d, dn) => this.OnRisProdotti(s, d, dn)}
                            OnErrore={this.OnErrore}
                        />
                    </div>
                    <div className="kt-portlet__foot kt-portlet__foot--fit">
                        <div className="kt-form login-form__actions kt-form login-form__actions--right">
                            <div className="row">
                                <div className="col kt-form__actions kt-form__actions--right">
                                    <ChiamaAPI
                                        Aggiornare={this.state.ID_Binder == 0 ? Glob.ChiamaAPINonAttivo : 1}
                                        URL={"/api/binder/?id_Binder=" + this.state.ID_Binder}
                                        OnRis={(s, d, dn) => this.OnRis(s, d, dn)}
                                        OnErrore={this.OnErrore}
                                    />
                                    <BottoneAPI
                                        Default
                                        Testo={Trad.Trad("Salva")}
                                        URL="/api/binder/"
                                        Metodo="POST"
                                        OnInvio={s => this.OnInvioSalva(s)}
                                        OnClick={(s, d) => this.OnClickSalva(s, d)}
                                        OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)}
                                        Visibile={this._Scrittura}
                                    />
                                    <button className={"btn btn-secondary " + this._VisibileScrittura} onClick={history.back} style={{ marginLeft: 5 }}>
                                        {Trad.Trad("Annulla")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/form/Binder.tsx